<template>
  <b-modal title="Lista de Medições" v-model="show" size="lg">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE TEMPLATES :::::::::::::::::::::::::::: -->
      <b-table
        id="table-checklist-temp"
        sticky-header
        style="max-height: 400px"
        bordered
        hover
        small
        head-variant="light"
        :items="getFilterChecklist(filtro)"
        :fields="fields.checklistTemplate"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="load(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>

    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="primary" scale="1.2" class="m-1" />
        <b-form-input
          id="med-filter-tmp"
          type="search"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Descrição"
          v-model="filtro"
        />
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useTemplateStore } from "@/stores/TemplateStore";
import TableFields from "@/tools/TableFields";
import ListaDeChecagem from "@/models_reports/ListaDeChecagem";

export default {
  name: "ChecklistTemplateModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      template: new ListaDeChecagem(),
      filtro: "",
    };
  },

  methods: {
    load(dados) {
      this.template.id = dados.id;
      this.template.descricao = dados.descricao;
      this.template.periodo = dados.periodo;
      this.template.itens = [];
      this.templateStore.LISTAR_ITENS_CHECKLIST(dados.id).then(() => {
        for (var i = 0; i < this.getChecklistItens.length; i++) {
          this.template.itens.push({
            id: this.getChecklistItens[i].id,
            item: this.getChecklistItens[i].item,
            conjunto: this.getChecklistItens[i].conjunto,
            descricao: this.getChecklistItens[i].descricao,
            laudo: this.getChecklistItens[i].laudo,
            listadechecagem: this.getChecklistItens[i].listadechecagem,
          });
        }
        this.$emit("loadTemplate", this.template);
        this.show = !this.show;
      });
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const templateStore = useTemplateStore();
    const { getChecklistItens } = storeToRefs(templateStore);
    const { getFilterChecklist } = storeToRefs(templateStore);

    return {
      store,
      templateStore,
      getChecklistItens,
      getFilterChecklist,
    };
  },
};
</script>

<style lang="scss" scoped>
#med-filter-tmp {
  width: 22rem;
}
</style>
